var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "formula-cell",
      class: [_vm.field.alignment, { "with-tooltip": _vm.showTooltip }],
    },
    [
      _c(
        "a-tooltip",
        {
          attrs: { title: _vm.tooltipContent, visible: _vm.showTooltip },
          on: { visibleChange: _vm.handleTooltipVisibility },
        },
        [
          _c(
            "div",
            {
              staticClass: "cell-content",
              on: {
                mouseenter: function ($event) {
                  _vm.showTooltip = true
                },
                mouseleave: function ($event) {
                  _vm.showTooltip = false
                },
              },
            },
            [
              _vm.loading
                ? _c(
                    "span",
                    { staticClass: "loading-indicator" },
                    [_c("a-icon", { attrs: { type: "loading" } })],
                    1
                  )
                : [
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.formattedValue)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "formula-badge" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("functions"),
                      ]),
                    ]),
                  ],
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }